

<template>
  <div>
    <!--    Order Promo Section Component-->
    <order-promo-area/>
    <!--    Food Menu Area Section Component-->
    <food-menu-area/>
    <!--    Best Pizza Section Component-->
    <best-pizza-area/>
    <!--    Pizza Slider Area Section Component
    <pizza-slider-area/>
    -->
    <!--    Double Fun Section Component
    <double-fun-area/>
    -->
    <!--    Delivery Section Component
    <delivery-area/>
    -->
    <!--    Blog Section Component
    <blog-area/>
    -->
  </div>
</template>
<script>
import DoubleFunArea from "../components/DoubleFunArea";
import OrderPromoArea from "../components/OrderPromoArea";
import BestPizzaArea from "../components/BestPizzaArea";
import PizzaSliderArea from "../components/PizzaSliderArea";
import FoodMenuArea from "../components/FoodMenuArea";
import DeliveryArea from "../components/DeliveryArea";
import BlogArea from "../components/BlogArea";

export default {
  name: 'Home',
  components: {BlogArea, DeliveryArea, FoodMenuArea, PizzaSliderArea, BestPizzaArea, OrderPromoArea, DoubleFunArea}
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue